// extracted by mini-css-extract-plugin
module.exports = {"form":"rules_form__3_5SY","block":"rules_block__1ey6J","item":"rules_item__c2wyu","filter":"rules_filter__1WBXr","selectDevice":"rules_selectDevice__2c5Bc"};